import { SourceType } from "../../../../../../../Wrap/Constants/Enums/Domain/SourceType"

export const AdviserChargesContents ={
    AcHeader : "Adviser charges",
    ProductLevel : "Product level",
    ChargesOnIllustration : "Charges on illustration",
    IAC : "Initial adviser charge",
    OAC : "Ongoing adviser charge",
    RIAC : "Regular payment adviser charge",
    Rate : "Rate",
    InputType : "Input by percentage or amount",
    Estimated : "Estimated",
    RIACTooltip : "Regular Initial Adviser Charge - charge for regular payments made by the client.",
    OACTooltip : "Ongoing Adviser Charge",
    IACTooltip : "Initial Adivser Charge",
    ChargesOnIllustrationToolTip : "If you choose to exclude adviser charges from your illustration, the adviser charges will be excluded from any projections and effect of deductions tables.",
    CopyFromSipp : "Would you like to use the same adviser charges as SIPP?",
    CopyFromIsa : "Would you like to use the same adviser charges as ISA?",
    CopyFromabrdnSipp : "Would you like to use the same adviser charges as abrdn SIPP?",
}

export const AdviserChargesValidation = {
    RIACEqualsOrGreaterThanRegularPayment :  "You have requested a Regular Initial Adviser Charge equal to or greater than the first regular Premium investment. Please note we will be unable to pay this charge if there is insufficient value in the pension when it is due",
    WrapCashOACWarningMessage : "Please be aware that we are unable to auto-disinvest from abrdn SIPP to fund ongoing charge set up to pay from Cash Account.",
    WrapCashIACWarningMessage:"Please ensure there is sufficient cash in the Cash Account to pay the initial adviser charge requested.",
    WrapCashDIACWarningMessage: "Please ensure there is sufficient cash in the Cash Account to pay the drawdown initial adviser charge requested.",
    CannotLessThanZero: "cannot be less than 0",
    CurrenciesNotMatching : "Currencies don't match",
    InsufficientCashForIAC : "There is insufficient cash to pay the initial adviser charge(s) requested",
    InvalidInput : "invalid input",
    IACWarningMessage:"Please note the initial adviser charge will only be paid when the selected payment has been received. Initial adviser charge cannot be taken from regular payments."
}

export const ChargeFromMap = {
    [SourceType.WrapCash] : "Cash Account",
    [SourceType.ProductCash] : "Product cash"
}

export const ChargeFromTypes  = [SourceType.ProductCash, SourceType.WrapCash]
